import script from "./FaqPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqPage.vue?vue&type=script&setup=true&lang=ts"

import "./FaqPage.vue?vue&type=style&index=0&id=1b29a934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b29a934"]])

export default __exports__